import styled from "styled-components";
import { themeTypes } from "../../../shared/styled/Theme";

const StyledMatchRoundInfo = styled.div`
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_headline};
  font-size: ${(props) => props.theme.mixins.pxToRem(12)};
  line-height: ${(props) => props.theme.figma.base.scale_1_75}px;
  letter-spacing: 0.04em;
  color: ${(props) =>
    props.theme.type == themeTypes.light
      ? props.theme.figma.base.color_black_100
      : props.theme.figma.base.color_white_100};
  opacity: ${(props) => (props.theme.type == themeTypes.light ? 0.45 : 0.6)};
  font-weight: 500;
  text-align: center;
  position: relative;
  padding-top: 16px;
`;

export { StyledMatchRoundInfo };
